import { jsx as _jsx } from "react/jsx-runtime";
const EllipseIcon = ({ color = '#575756', width = 8, height = 8 }) => {
    return (_jsx("svg", { width: width, height: height, viewBox: '0 0 8 8', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: _jsx("circle", { cx: '4', cy: '4', r: '4', fill: color }) }));
};
export default EllipseIcon;
